/* eslint-disable no-case-declarations */
const initState = {
  invoices: [],
  searched: [],
  invoice: {},
  totalCounts: {},
  toast: null,
  isProcessing: false,  
};

let failed; 
let success;
let messages;
let paymentStatus;

export const invoiceReducer = (state = initState, action) => {
  switch (action.type) {
  case 'RESET_INVOICE_STATE':
    return { 
      ...initState,
    };
  case 'RESET_TOAST_STATE':
    return {
      ...state,
      toast: null, 
      isProcessing: false,
    };
  case 'PROCESSING_INVOICE':
    return {
      ...state,
      toast: { type: 'LOADING', message: 'Please wait ...'},
      isProcessing: true,
    };

  case 'FETCH_INVOICES':
    return {
      ...state,
      searched: [],
      invoices: action.payload && action.payload.data,
      totalCounts: action.payload && action.payload.totalCounts,
      toast: {type: 'SUCCESS'},
      isProcessing: false,
    };
  case 'SEARCH_INVOICES':
    return {
      ...state,
      searched: action.payload && action.payload.data,
      totalCounts: action.payload && action.payload.totalCounts,
      toast: {type: 'SUCCESS'},
      isProcessing: false,
    };
  
  case 'GENERATE_INVOICE':  
  case 'UN_INVOICE':
  case 'PROCESS_PAYMENT':
    failed = [];  
    success = [];
    messages = [];    
    Object.entries(action.payload).forEach(entry => {  
      const id = Number(entry[0]);
      const msg = entry[1];
      msg.includes('ERROR') ? failed.push(id) : success.push(id);
      messages.push(`Invoice ${id} ${msg}`);      
    });
    return {
      ...state,
      toast: { type: 'SUCCESS', action: action.type, message: messages},
      isProcessing: false,
    };

  case 'ADD_INVOICE':
    return {
      ...state,      
      invoices: [...state.invoices, action.payload],
      toast: { type: 'SUCCESS', message: 'Invoice saved successfully.'},
      isProcessing: false,
    };     
  case 'UPDATE_INVOICE':
    return {
      ...state,      
      invoices: [...state.invoices.filter(item => item.id !== action.payload.id), Object.assign({}, action.payload)], 
      toast: { type: 'SUCCESS', message: 'Invoice updated successfully.' },
      isProcessing: false,
    };
  case 'INVOICE_ERROR':
    return {
      ...state,
      isProcessing: false,
      toast: { type: 'ERROR', message: action.payload},
    };
  default:
    return state;
  }
};
